// extracted by mini-css-extract-plugin
export default {"nort":"KitDanhSachOutlet_nort__VhRRa","container":"KitDanhSachOutlet_container__HbCY7","table-wrapper":"KitDanhSachOutlet_table-wrapper__IejDf"};